import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Head from 'next/head';
import Image from 'next/image';
import Slider from 'react-slick';

import careerHero from '@/assets/images/career-hero.png';
import careerMobileHero from '@/assets/images/career-mobile-hero.png';
import Employee1 from '@/assets/images/employee-testimonial/employee_1.png';
import Employee2 from '@/assets/images/employee-testimonial/employee_2.png';
import Employee3 from '@/assets/images/employee-testimonial/employee_3.png';
import Employee4 from '@/assets/images/employee-testimonial/employee_4.png';
import agile from '@/assets/images/icons/agile-icon.svg';
import build from '@/assets/images/icons/build-icon.svg';
import customer from '@/assets/images/icons/customer-icon.svg';
import growth from '@/assets/images/icons/growth.svg';
import harmony from '@/assets/images/icons/harmony-icon.svg';
import MFOLogo from '@/assets/images/icons/MFO-Blue-transparent.png';
// import muthootOneLogo from '@/assets/images/icons/MFO Blue (transparent).png';
import mind from '@/assets/images/icons/mind.svg';
import perk from '@/assets/images/icons/perk-icon.svg';
import product from '@/assets/images/icons/product-icon.svg';
import scale from '@/assets/images/icons/scale-icon.svg';
import stable from '@/assets/images/icons/stable-icon.svg';
import trust from '@/assets/images/icons/trust-icon.svg';
import wealth from '@/assets/images/icons/wealth-icon.svg';
import life1 from '@/assets/images/life-1.png';
import life2 from '@/assets/images/life-2.png';
import life3 from '@/assets/images/life-3.png';
import life4 from '@/assets/images/life-4.png';
import life5 from '@/assets/images/life-5.png';
import { testimonialSettings } from '@/utils/constants/carousel/testimonialSettings';
import { CareersSEO } from '@/utils/constants/MetaData';

const Careers = () => {
  return (
    <>
      <Head>
        <title>{CareersSEO.metaTitle}</title>
        <meta name="description" content={CareersSEO.metaDescription} />
        <meta
          property="og:description"
          content={CareersSEO.metaOGDescription}
        />
        <link rel="canonical" href="https://muthootfincorpone.com/careers/" />
      </Head>
      <main className="home career mfone-careers font-helvetica-neue">
        <section className="bg bg--dark blogs__hero">
          <div className="container">
            <div className="row align-items-center mfone-hero-flex mfone-gap-x-17 mfone-gap-y-32">
              <div className="col-12 col-xl-6">
                <h1 className="section__title text--white">
                  Life At Muthoot FinCorp ONE
                </h1>
                <p className="section__desc text--white">
                  Join us to unlock numerous career opportunities
                </p>
              </div>
              <div className="col-12 col-xl-6 d-flex align-items-center">
                <Image
                  style={{ color: undefined }}
                  className="hero-image"
                  src={careerHero}
                  alt="career hero"
                />
                <Image
                  style={{ color: undefined }}
                  className="hero-mobile-image"
                  src={careerMobileHero}
                  alt="career mobile hero"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="bg with-padding ownership">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <h2 className="section__title-small text--bold text--black">
                  Work Philosophy
                </h2>
                <p className="section__desc text--gray text--regular">
                  Muthoot FinCorp ONE believes in an ownership driven startup
                  culture, where cumulative success is paramount and each team
                  member is valued and nurtured.
                </p>
              </div>
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-md-6">
                    <div className="ownership__item rightBorder">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={customer}
                        alt="customer"
                      />
                      <div className="right">
                        <p className="text--black text--semi title">
                          Customer First
                        </p>
                        <p className="text--gray text--regular desc">
                          Every action of ours feeds back into the loop of
                          customer satisfaction. Happy Customers, happier us.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="ownership__item">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={agile}
                        alt="agile"
                      />
                      <div className="right">
                        <p className="text--black text--semi title">
                          Speed, Agile and Nimble
                        </p>
                        <p className="text--gray text--regular desc">
                          Sharp minds lead to faster solutions, allowing us to
                          constantly innovate at scale.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="ownership__item rightBorder">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={product}
                        alt="product"
                      />
                      <div className="right">
                        <p className="text--black text--semi title">
                          Product Mindset
                        </p>
                        <p className="text--gray text--regular desc">
                          A product-driven approach ensures that we&apos;re
                          aligned and focused on our primary goal - creating
                          effective change for our customers. Aligned and
                          focused on our primary goal - creating effective
                          change for our customers.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="ownership__item">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={scale}
                        alt="scale"
                      />
                      <div className="right">
                        <p className="text--black text--semi title">
                          Start small, Scale Fast
                        </p>
                        <p className="text--gray text--regular desc">
                          We respect every initiative and encourage
                          self-starters. Our work philosophy is o build well and
                          scale fast.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="ownership__item rightBorder">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={trust}
                        alt="trust"
                      />
                      <div className="right">
                        <p className="text--black text--semi title">
                          Trust and Respect
                        </p>
                        <p className="text--gray text--regular desc">
                          Contribution from each individual is valued and trust
                          between all cross functional teams ensures success.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="ownership__item mb-0 border-0 pb-0">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={harmony}
                        alt="harmony"
                      />
                      <div className="right">
                        <p className="text--black text--semi title">
                          Work-life Harmony
                        </p>
                        <p className="text--gray text--regular desc">
                          There’s work and life beyond work. We expect
                          individuals to experience life beyond office.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg bg--light home-trust">
          <div className="container">
            <div className="d-flex align-items-center justify-content-between trust__counter mt-0">
              <div className="item">
                <p className="text--bold text--black number">
                  28000<span className="text--darkBlue">+</span>
                </p>
                <p className="text--regular text--gray title">
                  Valued employees
                </p>
              </div>
              <div className="item">
                <p className="text--bold text--black number">
                  1 Cr.<span className="text--darkBlue">+</span>
                </p>
                <p className="text--regular text--gray title">
                  Happy customers
                </p>
              </div>
              <div className="item">
                <p className="text--bold text--black number">
                  135<span className="text--darkBlue">+</span>
                </p>
                <p className="text--regular text--gray title">
                  Years of legacy
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="bg with-padding life">
          <div className="container">
            <h2 className="section__title-small text--black text--bold pb-4">
              What to expect?
            </h2>
            {/* <h2 className="section__title-small text--black text--bold">
              Life at Muthoot FinCorp ONE
            </h2>
            <p className="section__desc text--regular text--gray">
              We are a passionate group of people who want to leverage
              technology to offer financial solutions to the common person. Join
              a select group of individuals creating disruptive products with
              powerful simplicity.
            </p> */}
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="ownership__item rightBorder">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={build}
                    alt="build"
                  />
                  <div className="right">
                    <p className="text--black text--semi title">
                      Build the future, Today
                    </p>
                    <p className="text--gray text--regular desc">
                      Build for scale in an ever expanding marketplace.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ownership__item rightBorder">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={mind}
                    alt="mind"
                  />
                  <div className="right">
                    <p className="text--black text--semi title">
                      Work with the brightest minds in the industry
                    </p>
                    <p className="text--gray text--regular desc">
                      Premium colleges, great pedigree and amazing teams.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ownership__item">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={growth}
                    alt="growth"
                  />
                  <div className="right">
                    <p className="text--black text--semi title">
                      Fast-paced growth
                    </p>
                    <p className="text--gray text--regular desc">
                      Wide exposure, and terrific mentors to accelerate
                      professional growth.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ownership__item rightBorder">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={stable}
                    alt="stable"
                  />
                  <div className="right">
                    <p className="text--black text--semi title">
                      Dynamic work environment: Stable yet exciting
                    </p>
                    <p className="text--gray text--regular desc">
                      Constant challenges that test the best in you
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ownership__item rightBorder">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={wealth}
                    alt="wealth"
                  />
                  <div className="right">
                    <p className="text--black text--semi title">
                      Attractive compensation with wealth-building ESOPs*
                    </p>
                    <p className="text--gray text--regular desc">
                      Attractive salaries and benefits.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="ownership__item">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={perk}
                    alt="perk"
                  />
                  <div className="right">
                    <p className="text--black text--semi title">
                      Perks & other benefits
                    </p>
                    <p className="text--gray text--regular desc">
                      Wholesome well-being and personal satisfaction
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row life__image-container">
              <div className="col-lg-4">
                <div className="life__image double">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={life1}
                    alt="lif1"
                  />
                </div>
                <div className="life__image double">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={life2}
                    alt="life2"
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="life__image">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={life3}
                    alt="life3"
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="life__image double">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={life4}
                    alt="life4"
                  />
                </div>
                <div className="life__image double">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={life5}
                    alt="life5"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg bg--light emp-testimonial">
          <div className="home__customer">
            <div className="container">
              <h2 className="section__title-small text--bold text--black text-center">
                Hear From Our Team
              </h2>
            </div>
            <div className="home__customer--slider">
              <Slider {...testimonialSettings} className="test-carousel">
                <div className="emp-slide-card">
                  <div className="emp-card emp-1">
                    <div className="square"></div>
                    <div className="emp-detail">
                      <Image
                        style={{ color: undefined }}
                        src={Employee1}
                        height={220}
                        alt="Employee 1"
                        className="desk-image"
                      />
                      <Image
                        style={{ color: undefined }}
                        src={Employee1}
                        height={170}
                        alt="Employee 1"
                        className="mob-image"
                      />
                      <div className="content">
                        <h1 className="content-head">Meet Utkarsh</h1>
                        <p className="content-des">
                          One thing I like most is the working culture. The
                          leadership is involved and work-life balance is good.
                        </p>
                      </div>
                    </div>
                    <Image
                      style={{ color: undefined }}
                      src={MFOLogo}
                      alt="MFO logo"
                      height={25}
                      className="logo desk-image"
                    />
                    <Image
                      style={{ color: undefined }}
                      src={MFOLogo}
                      alt="MFO logo"
                      height={20}
                      className="logo mob-image"
                    />
                  </div>
                </div>
                <div className="emp-slide-card">
                  <div className="emp-card emp-2">
                    <div className="square"></div>
                    <div className="emp-detail">
                      <Image
                        style={{ color: undefined }}
                        src={Employee2}
                        height={220}
                        alt="Employee 2"
                        className="desk-image"
                      />
                      <Image
                        style={{ color: undefined }}
                        src={Employee2}
                        height={170}
                        alt="Employee 2"
                        className="mob-image"
                      />
                      <div className="content">
                        <p className="content-des">
                          It is proactive and I am treated me as a high value
                          asset. Gives me ample learning opportunities both
                          professionally and personally.
                        </p>
                        <h1 className="content-head">Meet Vaishali</h1>
                      </div>
                    </div>
                    <Image
                      style={{ color: undefined }}
                      src={MFOLogo}
                      alt="MFO logo"
                      height={25}
                      className="logo desk-image"
                    />
                    <Image
                      style={{ color: undefined }}
                      src={MFOLogo}
                      alt="MFO logo"
                      height={20}
                      className="logo mob-image"
                    />
                  </div>
                </div>
                <div className="emp-slide-card">
                  <div className="emp-card emp-3">
                    <div className="square"></div>
                    <div className="emp-detail">
                      <Image
                        style={{ color: undefined }}
                        src={Employee3}
                        height={200}
                        alt="Employee 3"
                        className="desk-image"
                      />
                      <Image
                        style={{ color: undefined }}
                        src={Employee3}
                        height={150}
                        alt="Employee 3"
                        className="mob-image"
                      />
                      <div className="content">
                        <h1 className="content-head">Meet Bhargavi</h1>
                        <p className="content-des">
                          The work environment is friendly, and the culture
                          supports learning and growing together with speed and
                          agility.
                        </p>
                      </div>
                    </div>
                    <Image
                      style={{ color: undefined }}
                      src={MFOLogo}
                      alt="MFO logo"
                      height={25}
                      className="logo desk-image"
                    />
                    <Image
                      style={{ color: undefined }}
                      src={MFOLogo}
                      alt="MFO logo"
                      height={20}
                      className="logo mob-image"
                    />
                  </div>
                </div>
                <div className="emp-slide-card">
                  <div className="emp-card emp-4">
                    <div className="square"></div>
                    <div className="emp-detail">
                      <div className="content">
                        <p className="content-des">
                          I feel treasured as a person and offers me a
                          stress-free environment and unconditional learning
                          opportunities.
                        </p>
                        <h1 className="content-head">Meet Hadiya</h1>
                      </div>
                      <Image
                        style={{ color: undefined }}
                        src={Employee4}
                        height={200}
                        alt="Employee 4"
                        className="desk-image"
                      />
                      <Image
                        style={{ color: undefined }}
                        src={Employee4}
                        height={160}
                        alt="Employee 4"
                        className="mob-image"
                      />
                    </div>
                    <Image
                      style={{ color: undefined }}
                      src={MFOLogo}
                      alt="MFO logo"
                      height={25}
                      className="logo desk-image"
                    />
                    <Image
                      style={{ color: undefined }}
                      src={MFOLogo}
                      alt="MFO logo"
                      height={20}
                      className="logo mob-image"
                    />
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </section>
        {/* <section className="bg with-padding">
          <div className="container">
            <div className="career__cta">
              <div className="left order-lg-1 order-2">
                <h2 className="section__title-small text--black text--bold">
                  Join Us Today
                </h2>
                <p className="section__desc text--gray text--regular">
                  We are always looking for creative thinkers and revolutionary
                  leaders!
                </p>
                <div className="action-container">
                  <a className="custom__button custom__button--dark text--bold applyNow_button">
                    Apply Now
                  </a>
                  <a className="custom__button custom__button--dark border-btn text--semi">
                    View All Openings
                  </a>
                </div>
              </div>
              <Image 
style={{ color: undefined }}
                className="img-fluid order-lg-2 mfo-blue-logo-careers order-1"
                style={{ width: '400px' }}
                src={muthootOneLogo}
                alt="muthoot one logo"
              />
            </div>
          </div>
        </section> */}
      </main>
    </>
  );
};

export default Careers;
